import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import { CreatedDateRangePicker } from '../../ASN20/components/CreatedDateRangePicker'
import { LpnStateFilter } from '../components/LpnStateFilter'
import { WithAdjustmentsFilter } from '../components/WithAdjustmentsFilter'
import { eLpnState } from '../../../enums/eLpnState'
import { DateTime } from 'luxon'

const lpnStateLabels: Record<number, string> = {
  [eLpnState.Created]: 'Creado',
  [eLpnState.Pending]: 'Pendiente',
  [eLpnState.Finished]: 'Finalizado',
  [eLpnState.Manage]: 'Gestionar'
}

const lpnStateBackendTransformer = (rawValue: string): string => {
  return rawValue
}

const lpnStateDisplayTransformer = (rawValue: string): string => {
  const numericValue = parseInt(rawValue)
  return lpnStateLabels[numericValue] || rawValue
}

const withAdjustmentsBackendTransformer = (rawValue: string): string => {
  return rawValue
}

const withAdjustmentsDisplayTransformer = (rawValue: string): string => {
  if (rawValue === 'true') return 'Sí'
  if (rawValue === 'false') return 'No'
  return rawValue
}

const dateRangeBackendTransformer = (rawValue: string): string => {
  return rawValue
}

const dateRangeDisplayTransformer = (rawValue: string): string => {
  try {
    const parsed = JSON.parse(rawValue)
    const initialDate = parsed.initialCreatedDate || parsed.initialDate || ''
    const finalDate = parsed.finalCreatedDate || parsed.finalDate || ''

    if (initialDate && finalDate) {
      const formatDate = (dateStr: string) => {
        return DateTime.fromISO(dateStr).toFormat('dd/MM/yyyy')
      }
      return `${formatDate(initialDate)} - ${formatDate(finalDate)}`
    }
    return rawValue
  } catch {
    return rawValue
  }
}

export const filterOptions: FilterOption[] = [
  {
    key: 'brandId',
    label: 'Marca',
    type: 'precreated',
    order: 1
  },
  {
    key: 'asnId',
    label: 'ID ASN',
    type: 'text',
    order: 2
  },
  {
    key: 'asnNumber',
    label: 'ASN',
    type: 'text',
    order: 3
  },
  {
    key: 'lpn',
    label: 'LPN',
    type: 'text',
    order: 4
  },
  {
    key: 'sku',
    label: 'SKU',
    type: 'text',
    order: 5
  },
  {
    key: 'asnStateId',
    label: 'Estado ASN',
    type: 'precreated',
    order: 6
  },
  {
    key: 'lpnStateId',
    label: 'Estado LPN',
    type: 'custom',
    Component: LpnStateFilter,
    transformForBackend: lpnStateBackendTransformer,
    transformForDisplay: lpnStateDisplayTransformer,
    order: 7
  },
  {
    key: 'detailAsnStateId',
    label: 'Estado ASN Línea',
    type: 'precreated',
    order: 8
  },
  {
    key: 'batchNumber',
    label: 'Lote',
    type: 'text',
    order: 9
  },
  {
    key: 'expirationDateRange',
    label: 'Rango Fecha Vencimiento',
    type: 'custom',
    Component: CreatedDateRangePicker,
    transformForBackend: dateRangeBackendTransformer,
    transformForDisplay: dateRangeDisplayTransformer,
    order: 10
  },
  {
    key: 'withAdjustments',
    label: 'Con Ajustes',
    type: 'custom',
    Component: WithAdjustmentsFilter,
    transformForBackend: withAdjustmentsBackendTransformer,
    transformForDisplay: withAdjustmentsDisplayTransformer,
    order: 11
  },
  {
    key: 'createdDateRange',
    label: 'Rango Fecha Entrada',
    type: 'custom',
    Component: CreatedDateRangePicker,
    transformForBackend: dateRangeBackendTransformer,
    transformForDisplay: dateRangeDisplayTransformer,
    order: 12
  }
]
